<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

  <div class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent">
    <div class="flex-1 min-w-0">
      <div class="flex">
        <a class="inline-flex items-center -ml-1.5 text-secondary font-medium" [routerLink]="'/profile-dashboard'">
          <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
          <span class="ml-1">Back</span>
        </a>
      </div>
      <div class="mt-2">
        <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
          List Of Communities
        </h2>
      </div>
    </div>

    <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4" *ngIf="allowCommunityCreation ||  isAdmin">
      <!-- <button mat-flat-button color="primary" [routerLink]="'/create-community'">
        Create Community
      </button> -->
    </div>
  </div>
 
  <div class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card" cdkScrollable>
    <div class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between">
      <div *ngIf="dataSource.length === 0" 
           class="w-full py-4 text-center font-bold text-lg text-gray-600 dark:text-gray-300">
        No Community found.
      </div>

    <!-- <div class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
        Community Information
      </div>
    </div> -->

    <!-- <div class="my-5 border-t"></div> -->

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-full" *ngIf="communityData.length > 0">

      <!-- Community Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Community Name </th>
        <td mat-cell *matCellDef="let element" class="hover:bg-gray-100 cursor-pointer">
          {{ element.name || '--' }}
        </td>
      </ng-container>

      <!-- Location Column -->
      <!-- <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef> Location </th>
        <td mat-cell *matCellDef="let element">
          {{ element.location || '--' }}
        </td>
      </ng-container> -->

      <!-- Contact Phone Column -->
      <!-- <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef> Contact Phone </th>
        <td mat-cell *matCellDef="let element">
          {{ element.contactPhone || '--' }}
        </td>
      </ng-container> -->

      <!-- Table Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="['name']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name'];" class="hover:bg-gray-100 cursor-pointer"></tr>

    </table>

  </div>

</div>
